import { Directive, ElementRef, EmbeddedViewRef, HostListener, Input, OnDestroy, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[appTooltip]',
	standalone: true
})
export class TooltipDirective implements OnDestroy {
	@Input() tooltipText!: any[];
	@Input() tooltipTop: number = 0;
	@Input() tooltipLeft: number = 0;
	@Input() tooltipTemplate!: TemplateRef<any>;
	@Input() tooltipContext: any;

	tooltipElement!: HTMLElement | null;
	private tooltipView: EmbeddedViewRef<any> | null = null;

	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private viewContainerRef: ViewContainerRef,
	) { }

	@HostListener('mouseenter') onMouseEnter() {
		if (!this.tooltipElement) {
			this.showTooltip();
		}
	}

	@HostListener('mouseleave') onMouseLeave() {
		if (this.tooltipElement) {
			this.hideTooltip();
		}
	}

	ngOnDestroy(): void {
		this.hideTooltip();
	}

	private showTooltip() {
		if (!this.tooltipTemplate) return;

		const view = this.viewContainerRef.createEmbeddedView(this.tooltipTemplate, this.tooltipContext || {});
		view.detectChanges();
		this.tooltipView = view;
		this.tooltipElement = this.renderer.createElement('div');
		this.renderer.addClass(this.tooltipElement, 'app-tooltip-overlay');

		view.rootNodes.forEach(node => {
			this.renderer.appendChild(this.tooltipElement, node);
		});

		const hostElemRect = this.el.nativeElement.getBoundingClientRect();
		const hostElemHeight = hostElemRect.height;
		const tooltipTopPosition = hostElemRect.top + hostElemHeight + window.scrollY;
		const tooltipLeftPosition = hostElemRect.left + window.scrollX;

		this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
		this.renderer.setStyle(this.tooltipElement, 'top', `${tooltipTopPosition + this.tooltipTop}px`);
		this.renderer.setStyle(this.tooltipElement, 'left', `${tooltipLeftPosition + this.tooltipLeft}px`);
		this.renderer.setStyle(this.tooltipElement, 'z-index', '1000');

		this.renderer.appendChild(document.body, this.tooltipElement);
	}

	private hideTooltip() {
		if (this.tooltipElement) {
			this.renderer.removeChild(document.body, this.tooltipElement);
			this.tooltipElement = null;
		}
		if (this.tooltipView) {
			this.tooltipView.destroy();
			this.tooltipView = null;
		}
	}
}

